import { UserService, AuthenticationError } from "../../services/user.service";
import {
  TokenService,
  UserDetail,
  TokenServiceApp,
  UserIdService
} from "../../services/storage.service";
import router from "../../router";
import { Statistic } from "ant-design-vue";

const state = {
  authenticating: false,
  accessToken: TokenService.getToken(),

  accessData: TokenServiceApp.getToken(),
  authenticationErrorCode: 0,
  authenticationError: "",
  registerResponse: "",
  isRegistered: false,
  userUpdateResponse: "",
  userinfo: UserDetail.getLoggedUser(),
  userToken: null,
  // userinfo: "",
};

const getters = {
  loggedIn: (state) => {
    return state.accessToken ? true : false;
  },

  loggedInApp: (state) => {
    return state.accessData ? true : false;
  },

  tokenUser: (state) => {
    return state.userToken;
  },

  authenticationErrorCode: (state) => {
    return state.authenticationErrorCode;
  },

  authenticationError: (state) => {
    return state.authenticationError;
  },

  getRegisterResponse: (state) => {
    return state.registerResponse;
  },

  getIsRegistered: (state) => {
    return state.isRegistered;
  },
  getUserUpdateResponse: (state) => {
    return state.userUpdateResponse;
  },

  authenticating: (state) => {
    return state.authenticating;
  },

  loggedUser: (state) => {
    return state.userinfo;
  },
};

const actions = {
  async login({ commit }, { username, password }) {
    commit("loginRequest");

    try {
      const res = await UserService.login(username, password);
      // console.log("TOKEN:", token);
      commit("loginSuccess", res.token);
      // commit("userToken", token.user_id);
      // localStorage.setItem("user_id", JSON.stringify(token.user_id));
      UserIdService.saveUserId(res.user_id)

      const detail = await UserService.userinfo(res.token);
        // console.log("USER DETAIL:" + detail);
      commit("userDetail", detail);

      // Redirect the user to the page he first tried to visit or to the home view
      router.push(router.history.current.query.redirect || "/");

      return true;
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit("loginError", {
          errorCode: e.errorCode,
          errorMessage: e.message,
        });
      }

      return false;
    }
  },

  async socialLogin({ commit }, { sm_id, sm_name }) {
    commit("loginRequest");
    // console.log(sm_id, sm_name, "inside login function")

    try {
      const res = await UserService.socialLogin(sm_id, sm_name);
      

      commit("loginSuccessApp", res.data.token);
      localStorage.setItem("user_id", JSON.stringify(res.data.user_id));
      // localStorage.setItem("user_id", JSON.stringify(123456));



      const detail = await UserService.userinfo(res.data.token);
      commit("userDetail", detail);

      // router.push(router.history.current.query.redirect || "/");
      // alert("hello social login");

      return true;
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit("loginError", {
          errorCode: e.errorCode,
          errorMessage: e.message,
        });
      }

      return false;
    }
  },

  logout({ commit }) {
    UserService.logout();
    // UserIdService.removeUserId();
    commit("logoutSuccess");
    router.push("/login");
  },

  async register(
    { commit },
    { first_name, last_name, phone, otp, email, password, address }
  ) {
    let username = phone;
    commit("registerRequest");

    try {
      const data = await UserService.register(
        username,
        first_name,
        last_name,
        phone,
        otp,
        email,
        password,
        address
      );

      commit("registerResponse", data);
      commit("registerSuccess");
      router.push(router.history.current.query.redirect || "/p/login");

      return true;
    } catch (e) {
      commit("registerResponse", e);

      return false;
    }
  },

  async socialRegister(
    { commit },
    {
      first_name,
      last_name,
      email,
      username,
      password,
      registration_source,
      sm_name,
      sm_id,
    }
  ) {
    commit("registerRequest");

    try {
      const data = await UserService.socialRegister(
        first_name,
        last_name,
        email,
        username,
        password,
        registration_source,
        sm_name,
        sm_id
      );

      commit("registerResponse", data);
      commit("registerSuccess");
      // alert("hello register request")
      return true;
    } catch (e) {
      commit("registerResponse", e);

      return false;
    }
  },

  async updateUser(
    { commit },
    { username, first_name, last_name, phone, address }
  ) {
    commit("registerRequest");

    try {
      const data = await UserService.userupdate(
        username,
        first_name,
        last_name,
        phone,
        address
      );
      commit("userUpdateResponse", data);
      commit("registerSuccess");

      return true;
    } catch (e) {
      commit("userUpdateResponse", e);

      return false;
    }
  },
};

const mutations = {
  loginRequest(state) {
    state.authenticating = true;
    state.authenticationError = "";
    state.authenticationErrorCode = 0;
  },

  loginSuccess(state, accessToken) {
    state.accessToken = accessToken;
    state.authenticating = false;
  },

  userToken(state, user_token) {
    // alert(user_token);
    state.userToken = user_token;
  },

  loginSuccessApp(state, data) {
    state.accessData = data;
    state.authenticating = false;
  },

  loginError(state, { errorCode, errorMessage }) {
    state.authenticating = false;
    state.authenticationErrorCode = errorCode;
    state.authenticationError = errorMessage;
  },

  logoutSuccess(state) {
    state.accessToken = "";
    state.accessData = "";

    state.userinfo = {};
  },

  userDetail(state, detail) {
    state.userinfo = detail;
  },

  registerRequest(state) {
    state.authenticating = true;
  },

  registerSuccess(state) {
    state.authenticating = false;
  },

  registerResponse(state, e) {
    state.registerResponse = e;
    state.isRegistered = true;
  },
  userUpdateResponse(state, e) {
    state.userUpdateResponse = e;
    state.isRegistered = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
